module.exports = __webpack_public_path__ + "img/step-14.06f44ae4.jpg";